import * as Types from '../../../../__generated__/schema';

import {
  ActorTeaserAPIToken,
  ActorTeaserUser,
} from '../../../graphql/fragments/ActorTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import { ActorTeaser } from '../../../graphql/fragments/ActorTeaser.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RunAiAuthorDetectionVariables = Types.Exact<{
  input: Types.AIAuthorDetectionInput;
}>;

export type RunAiAuthorDetection = {
  aiAuthorDetection: Pick<
    Types.AIInferenceStream,
    'streamName' | 'streamId' | 'pinned' | 'saved' | 'createdAt' | 'parentStreamId'
  > & { createdBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser> };
};

export const RunAiAuthorDetectionDocument = gql`
  mutation RunAiAuthorDetection($input: AIAuthorDetectionInput!) {
    aiAuthorDetection(input: $input) {
      streamName
      streamId
      pinned
      saved
      createdBy {
        ...ActorTeaser
      }
      createdAt
      parentStreamId
    }
  }
  ${ActorTeaser}
`;
export type RunAiAuthorDetectionMutationFn = Apollo.MutationFunction<
  RunAiAuthorDetection,
  RunAiAuthorDetectionVariables
>;

/**
 * __useRunAiAuthorDetection__
 *
 * To run a mutation, you first call `useRunAiAuthorDetection` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunAiAuthorDetection` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runAiAuthorDetection, { data, loading, error }] = useRunAiAuthorDetection({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunAiAuthorDetection(
  baseOptions?: Apollo.MutationHookOptions<RunAiAuthorDetection, RunAiAuthorDetectionVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RunAiAuthorDetection, RunAiAuthorDetectionVariables>(
    RunAiAuthorDetectionDocument,
    options,
  );
}
export type RunAiAuthorDetectionHookResult = ReturnType<typeof useRunAiAuthorDetection>;
export type RunAiAuthorDetectionMutationResult = Apollo.MutationResult<RunAiAuthorDetection>;
export type RunAiAuthorDetectionMutationOptions = Apollo.BaseMutationOptions<
  RunAiAuthorDetection,
  RunAiAuthorDetectionVariables
>;
export function mockRunAiAuthorDetection({
  data,
  variables,
  errors,
}: {
  data: RunAiAuthorDetection;
  variables?: RunAiAuthorDetectionVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: RunAiAuthorDetectionDocument, variables },
    result: { data, errors },
  };
}
